module.exports = __webpack_public_path__ + "static/img/jdk.ce42ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jdk.png
// module id = 61UZ
// module chunks = 37